import axios from "axios";
import { getCookie } from "../utils/auth";
export const baseURL = "https://api.chaoangoods.com";
// export const baseURL = 'http://localhost:8080'
// export const baseURL = 'https://api.chaoangoods.com'
// create an axios instance
const service = axios.create({
  baseURL: "/api", // 统一添加/api前缀
  baseURL: "https://api.chaoangoods.com", // url = base url + request url
  // baseURL: 'https://api.chaoangoods.com',
  // baseURL: 'http://localhost:8080',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
});

// request interceptor
service.interceptors.request.use((config) => config);

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做某事，比如说 设置token
    // config.headers['Authorization'] = 'token';
    //设置通用请求头格式
    config.headers["Authorization"] = getCookie("token");
    config.headers["Accept"] = "*/*";
    if (config.method === "post" || config.method == "put") {
      let configData = {};
      if (config.data) {
        configData = config.data;
      }
      // configData.enOrCn = "en";
      configData.currencyCode = (process.client ? localStorage.getItem("rate") : null) || "USD";
      config.data = configData;
    }

    if (config.method === "get") {
      config.url += `/en`;
    }
    return config;
  },
  (error) => {
    // 请求错误时做些事
    return Promise.reject(error);
  },
);
// response interceptor
service.interceptors.response.use((response) => {
  return response.data;
});

export default service;
